// Generated by OrchestKit Claude Plugin
// Created: 2026-09-12

/**
 * Types des retours de marchandise — Q-039 à Q-042.
 */

export type Remboursement = 'AVOIR' | 'ESPECES' | 'CREANCE';
export type Destination = 'STOCK' | 'REBUT';

/** Une ligne de l'historique des retours. */
export interface Retour {
  id: string;
  numero: string;
  montant: number;
  remboursement: Remboursement;
  hors_fenetre: boolean;
  motif: string;
  horodatage_serveur: string;
  vente_numero: string;
  /** Boutique où le client s'est présenté. */
  boutique: string;
  /** Boutique qui avait VENDU : les deux peuvent différer (Q-041). */
  boutique_origine: string;
  enregistre_par: string;
  client_nom: string | null;
  client_prenom: string | null;
  lignes: number;
  articles: number;
  articles_rebut: number;
}

/** Ce qui reste reprenable sur une vente, tel que le serveur le calcule. */
export interface Retournable {
  vente_id: string;
  numero: string;
  boutique_origine_id: string;
  client_id: string | null;
  statut: string;
  jours_ecoules: number;
  fenetre_jours: number;
  hors_fenetre: boolean;
  lignes: LigneRetournable[];
}

export interface LigneRetournable {
  vente_ligne_id: string;
  produit_id: string;
  designation: string;
  quantite_vendue: number;
  quantite_deja_retournee: number;
  quantite_retournable: number;
  /** Prix NET réellement payé pour une unité, remise comprise. */
  prix_unitaire_net: number;
}

/** Longueur minimale du motif, comme le serveur (schéma de `POST /retours`). */
export const MOTIF_MIN = 10;

/**
 * Libellés des formes de remboursement.
 *
 * `CREANCE` n'est jamais un choix de l'utilisateur : le serveur l'impose
 * quand la vente a une dette ouverte, parce que rendre de l'argent à qui en
 * doit encore reviendrait à financer son crédit (Q-040).
 */
export const REMBOURSEMENTS: Record<Remboursement, string> = {
  AVOIR: 'Avoir',
  ESPECES: 'Espèces',
  CREANCE: 'Réduction de la dette',
};

export const DESTINATIONS: Record<Destination, string> = {
  STOCK: 'Remise en rayon',
  REBUT: 'Rebut (invendable)',
};

/** Un IMEI retourné — l'unité précise rendue, quand elle était connue. */
export interface ImeiRetourne {
  imei: string | null;
  imei2: string | null;
}

export interface LigneRetourDetail {
  produit_id: string;
  designation: string;
  quantite: number;
  prix_unitaire_net: number;
  destination: Destination;
  imeis: ImeiRetourne[];
}

/** Détail complet d'un retour — `GET /retours/:id`. */
export interface RetourDetail {
  id: string;
  numero: string;
  vente_id: string;
  vente_numero: string;
  boutique: string;
  boutique_origine: string;
  enregistre_par: string;
  client_nom: string | null;
  client_prenom: string | null;
  montant: number;
  remboursement: Remboursement;
  hors_fenetre: boolean;
  motif: string;
  horodatage_serveur: string;
  lignes: LigneRetourDetail[];
}
